/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListAudienceOptions } from "../funcs/accessListAudienceOptions.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAudienceOptionsResult } from "../models/components/listaudienceoptionsresult.js";
import {
  ListAudienceOptionsRequest,
  ListAudienceOptionsSecurity,
} from "../models/operations/listaudienceoptions.js";
import { unwrapAsync } from "../types/fp.js";
export type AudienceOptionsQueryData = ListAudienceOptionsResult;

export function prefetchAudienceOptions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAudienceOptionsRequest | undefined,
  security?: ListAudienceOptionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAudienceOptionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAudienceOptionsQuery(
  client$: GramCore,
  request?: ListAudienceOptionsRequest | undefined,
  security?: ListAudienceOptionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AudienceOptionsQueryData>;
} {
  return {
    queryKey: queryKeyAudienceOptions({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function audienceOptionsQueryFn(
      ctx,
    ): Promise<AudienceOptionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListAudienceOptions(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAudienceOptions(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listAudienceOptions", parameters];
}
